module.exports = __webpack_public_path__ + "static/media/profile-img-accent.fc17ee72.svg";